import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import TranslateNew from '@translate/TranslateNew';
import { subscriptionStyle } from "./subscription.style";
import { connect } from 'react-redux';
import * as SubscriptionActions from '@services/subscription/subscription.action';
import { ISubscribe, ISubscription, SubscriptionPlatform } from '@app-types/websocket/subscription.types';
import Button from '@components/common/button/Button';
import { CircularProgress, Typography } from '@material-ui/core';
import cordovaContext from "src/cordovaContext";
import UnlockIcon from '@material-ui/icons/LockOpenRounded';
import NotificationsIcon from '@material-ui/icons/NotificationsRounded';
import StarIcon from '@material-ui/icons/FlareRounded';
import 'cordova-plugin-purchase';
import { RouteComponentProps, withRouter  } from 'react-router-dom';
import { styleColors } from 'src/main.style';
import QuickDialog from "@components/common/dialog/dialog.component";
import { IFamilyMember } from '@app-types/websocket/family.types';
import { getOS } from '@helpers/osDetection';
import * as UserActions from '@services/user/user.actions';
import { createSubscriptionStoreDiagnostic, isReportableSubscriptionStoreError } from './subscriptionDiagnostics';
import { PurchaseFeedback, purchaseFeedbackForOrderError } from './purchaseFeedback';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof subscriptionStyle>, RouteComponentProps {
  accountId: number;
  subscriptions: ISubscription[];
  subscribe: (receipt: ISubscribe) => any;
  callBackSuccess: () => void;
  isOnboarding?: boolean;
  isFemale:boolean
  reportProblem: (msg:string) => void;
  multiGroup:boolean;
}

interface IState {
  buyRequestTime:number;
  transactionState:CdvPurchase.TransactionState | undefined;

  price:string;
  daysOfTrial:number;
  product:string;
  showPrivacyPolicy:boolean;

  showErrorState:boolean;
  storeIsInitialized:boolean;
  alreadyHasASubscription:boolean;
  purchaseNotPossible:boolean,
  deviceReady:boolean;
  purchaseFeedback:PurchaseFeedback|undefined;
}

class Subscription extends React.Component<IProps, IState>  {
  private timer:NodeJS.Timeout|null = null;
  private forward:NodeJS.Timeout|null = null;
  private updates:number = 0;
  // evaluated lazily so the cordova device plugin (available after "deviceready") can be used
  private get platform():CdvPurchase.Platform {
    return getOS()==='IOS'
      ?CdvPurchase.Platform.APPLE_APPSTORE
      :getOS()==='ANDROID'
        ?CdvPurchase.Platform.GOOGLE_PLAY
        :CdvPurchase.Platform.TEST;
  }

  constructor(props: IProps) {
    super(props);
    this.state = {
      buyRequestTime:0,
      transactionState: undefined,

      product:"monthly2",
      price: "89 SEK",
      daysOfTrial: 7,
      showPrivacyPolicy:false,

      storeIsInitialized:false,
      purchaseNotPossible:false,
      alreadyHasASubscription:false,
      showErrorState:false,
      deviceReady:false,
      purchaseFeedback:undefined,
    };
  }
  
  public componentDidMount() {
    document.addEventListener("deviceready", () => {
      this.setState({deviceReady:true});
      this.tick();
    }, false);
  }

  public componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.forward) {
      clearTimeout(this.forward);
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>): void {
    if (prevProps.subscriptions !== this.props.subscriptions
      && !this.state.alreadyHasASubscription
      && this.hasActiveBackendSubscription(this.props.subscriptions)) {
      this.setState({ alreadyHasASubscription: true });
      return;
    }

    if (this.state.alreadyHasASubscription && this.state.buyRequestTime > 0  && prevState.alreadyHasASubscription === false) {
      this.forward = setTimeout(() => this.props.callBackSuccess(), 1500);
    }
  }

  public render() {
    const isCordovaApp = this.context;
    const hasActiveBackendSubscription = this.hasActiveBackendSubscription(this.props.subscriptions);

    let freeDays = 0;
    for (const s of this.props.subscriptions) {
      if (s.expirationTime && s.expirationTime > Date.now()) {
        const daysLeft = Math.round((s.expirationTime - Date.now())/(1000*60*60*24));
        if (daysLeft > freeDays) {
          freeDays = daysLeft;
        }
      }
    }

    if (freeDays > 10 && this.state.buyRequestTime === 0) {
      return this.renderFree(freeDays+tn.lang.freeTrial);
    } else if (hasActiveBackendSubscription) {
      return this.renderScreen(<span>{tn.lang.continue}</span>, this.props.callBackSuccess);
    } else if (isCordovaApp && !this.state.deviceReady) {
      return this.renderScreen(this.progress(tn.lang.initializing), undefined);
    } else if (!isCordovaApp) {
      // return this.renderWithoutTrialScreen(<span>{tn.lang.continue}</span>, this.props.callBackSuccess);
      // return this.renderScreen(<span>{tn.lang.continue}</span>, this.props.callBackSuccess);
      return this.renderHalt();
    } else if (this.state.alreadyHasASubscription) {
      return this.renderScreen(<span>{tn.lang.continue}</span>, this.props.callBackSuccess);
    } else if (!this.state.storeIsInitialized) {
      if (this.state.showErrorState) {
        return (<div style={{zIndex:1}}>

          <div>{tn.lang.subscriptionStoreUnavailable(this.storeName)}</div><br/><br/>
          <div>{tn.lang.subscriptionContactSupport}</div>
          {this.supportLink()}

        </div>);
      } else {
        // we are initializing the store lets wait
        return this.renderScreen(this.progress(tn.lang.initializing), undefined);
      }
    } else if (this.state.transactionState === undefined || this.state.transactionState === CdvPurchase.TransactionState.UNKNOWN_STATE) {
      if (Date.now() - this.state.buyRequestTime < 2000) {
        // something is strange here we clicked buy but has no transaction. lets wait a little
        return this.renderScreen(this.progress(tn.lang.validatingSub), undefined);
      } else {
        // free to buy here
        return this.renderScreen(<span>{tn.lang.subscriptionBuy(this.state.daysOfTrial)}</span>, () => this.subscribe());
      }
    } else { // we have an ongoing transaction
      if (this.state.transactionState === CdvPurchase.TransactionState.APPROVED) {
        // purchase is approved but not confirmed (i.e. bank transfer not done yet)
        if (this.state.buyRequestTime === 0) {
          return this.renderScreen(this.progress(tn.lang.subValidatingExisintg), undefined);
        } else {
          return this.renderScreen(this.progress(tn.lang.validatingSub), undefined);
        }
      } else if (this.state.transactionState === CdvPurchase.TransactionState.CANCELLED) {
        // lets allow tapping the buy buttaon again
        return this.renderScreen(<span>{tn.lang.subscriptionBuy(this.state.daysOfTrial)}</span>, () => this.subscribe())
      } else if (this.state.transactionState === CdvPurchase.TransactionState.FINISHED) {
        if (this.state.buyRequestTime > 0) {
          return this.renderScreen(<span>{tn.lang.continue}</span>, this.props.callBackSuccess)
        } else { // an old finished transaction that is no longer valid? (if so this.state.alreadyOwned would be true...)
          return this.renderScreen(<span>{tn.lang.subscriptionBuy(this.state.daysOfTrial)}</span>, () => this.subscribe())
        }
      } else if (this.state.transactionState === CdvPurchase.TransactionState.INITIATED) {
        // waiting for pending transaction
        return this.renderScreen(this.progress(tn.lang.waiting), undefined);
      } else if (this.state.transactionState === CdvPurchase.TransactionState.PENDING) {
        if (this.state.buyRequestTime === 0) {
          // lets allow tapping the buy button again
          return this.renderScreen(<span>{tn.lang.subscriptionBuy(this.state.daysOfTrial)}</span>, () => this.subscribe())
        } else {
          // waiting for pending transaction
          return this.renderScreen(this.progress(tn.lang.validatingSub), undefined);
        }
      } else {
        return (<div>strange...</div>); 
      }
    }
    
  }

  private progress(text:string):JSX.Element {
    return (<span style={{display: 'flex', width: '100%', alignItems: 'center', marginLeft: '-24px', gap: '10px'}}>
        <div><CircularProgress style={{color:styleColors.greyMedium3}}/></div>
        <span style={{flex:1}}>{text}</span>
      </span>); 
  }

  private subscribe = () => {

    const store = CdvPurchase.store;
    if (store && store.isReady) {
      if (this.platform === CdvPurchase.Platform.APPLE_APPSTORE && !store.checkSupport(this.platform, "order")) {
        // In-app purchases are turned off on this iPhone (Screen Time or device management).
        // Its initialize error is already reported, so explain it to the user instead.
        this.setState({ purchaseFeedback: "purchasesRestricted" });
        return;
      }
      const product = store.get(this.state.product, this.platform);
      if (product) {
        const offer = product.getOffer();
        if (offer) {
          // Store.order forwards returned store errors to store.error(), where they are
          // reported centrally. The returned error only decides what to tell the user,
          // and only an unexpected rejected promise is reported here.
          store.order(offer).then((error:any) => {
            const purchaseFeedback = purchaseFeedbackForOrderError(error);
            if (purchaseFeedback) {
              this.setState({ purchaseFeedback });
            }
          }).catch((error:any) => {
            this.reportStoreDiagnostic("order-rejected", error, {
              offerId: offer.id,
              offerCanPurchase: offer.canPurchase,
            });
          });
          this.setState({ buyRequestTime:Date.now() });
        } else {
          this.reportStoreDiagnostic("offer-missing");
          this.props.callBackSuccess();
        }
      } else {
        this.reportStoreDiagnostic("product-missing-on-order");
        this.props.callBackSuccess();
      }
    } else {
      this.reportStoreDiagnostic("store-not-ready-on-order");
      this.props.callBackSuccess();
    }
  }

  private reportStoreDiagnostic(stage:string, error?:any, details?:{[key:string]:any}) {
    if (!isReportableSubscriptionStoreError(error)) {
      return;
    }

    this.props.reportProblem(createSubscriptionStoreDiagnostic(
      stage,
      this.state.product,
      this.platform,
      error,
      {
        accountId: this.props.accountId,
        purchaseNotPossible: this.state.purchaseNotPossible,
        deviceReady: this.state.deviceReady,
        transactionState: this.state.transactionState,
        ...details,
      },
    ));
  }

  private get storeName():string {
    return this.platform === CdvPurchase.Platform.APPLE_APPSTORE ? "App Store" : "Google Play";
  }

  private supportLink() {
    const email = tn.lang.subscriptionSupportEmail;
    return (<a href={"mailto:"+email+"?subject=I cannot start a subscription&body=My account id is "+this.props.accountId+" please help me set up a subscription."}
      target="_blank" rel="noopener noreferrer">
      {email}
    </a>);
  }

  private closePurchaseFeedback = () => {
    this.setState({ purchaseFeedback: undefined });
  }

  private renderPurchaseFeedback() {
    const feedback = this.state.purchaseFeedback;
    if (feedback === undefined) {
      return null;
    }

    const message = feedback === "purchasesRestricted" ? tn.lang.subscriptionPurchasesRestricted
      : feedback === "appStore" ? tn.lang.subscriptionAppStoreFailed
      : feedback === "googlePlay" ? tn.lang.subscriptionGooglePlayFailed
      : tn.lang.subscriptionPurchaseFailed;

    return (
      <QuickDialog
        open={true}
        onClose={this.closePurchaseFeedback}
        title={tn.lang.subscriptionPurchaseFailedTitle}
        content={<>
          <div>{message}</div><br/>
          <div>{tn.lang.subscriptionContactSupport}</div>
          {this.supportLink()}
        </>}
        actions={<Button onClick={this.closePurchaseFeedback} variant="text">{tn.lang.OK}</Button>}
      />
    );
  }

  private renderScreen(buttonText:JSX.Element, buttonAction:(()=> void)|undefined) {
    if (this.state.daysOfTrial > 2) {
      return this.renderWithTrialScreen(buttonText, buttonAction);
    } else {
      return this.renderWithoutTrialScreen(buttonText, buttonAction);
    }
  }

  private renderHalt() {
    const style = this.props.classes;

    return (<>
      <Typography component={"div"} style={{flex:1, zIndex:1}}>
        <div style={{fontSize:'14px'}}>{tn.lang.subscriptionWeb}</div>
      </Typography>
      <div className={this.props.classes.imageContent}>
        <img  className={this.props.classes.halfImage} src={this.props.isFemale?"serenity-female.png":"serenity-male.png"} alt="Happy Parent"/>
      </div>
      {(this.props.isOnboarding === undefined || this.props.isOnboarding === false || this.props.multiGroup) && 
        <Button onClick={() => {this.props.history.push("/app/settings/:userId");}}>{tn.lang.settings}</Button>}
      <div className={style.bottomContent} style={{marginBottom: '-20px'}}>
        <Button
          href={"https://varannanvecka.app/install/NOSUB"}
          variant='contained'
          color='primary'
          size='large'
          fullWidth={true}
        >
          {tn.lang.continue}
        </Button>
        <div onClick={() => this.setState({showPrivacyPolicy:true})}
          style={{position: 'absolute', bottom: '10px', opacity: 0.84, fontSize: '12px', fontWeight: 300}}>terms & privacy policy</div>
      </div>
      {this.state.showPrivacyPolicy?
          <QuickDialog
            open={this.state.showPrivacyPolicy}
            onClose={() => this.setState({showPrivacyPolicy: false})}
            title={tn.lang.privacyPolicyShort}
            content={tn.lang.privacyPolicyContent}
            actions={<div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
              <Button onClick={() => {this.props.history.push("/app/settings/:userId");}}>{tn.lang.settings}</Button>
              <Button
                onClick={() => this.setState({showPrivacyPolicy: false})}
                variant="text">
                {tn.lang.OK}
              </Button></div>}
          />:null}
    </>)
  }

  private renderWithoutTrialScreen(buttonText:JSX.Element, buttonAction:(()=> void)|undefined) {
    const style = this.props.classes;

    return (
      <>
        <Typography component={"div"} style={{flex:1, zIndex:1}}>
          <div style={{fontSize:'14px'}}>{tn.lang.subscriptionSubTitleMonth(0, this.state.price)}</div>
          <div style={{fontSize:'14px'}}>{tn.lang.subscriptionInvitedFree}</div>

          <div className={style.testimonial}>
            <div style={{fontSize:'36px', lineHeight: '36px', letterSpacing: '6px'}}>⭐⭐⭐⭐⭐</div>
            <div style={{fontSize:'18px', fontWeight:700}}>THE co-parenting solution</div>
            <div>This app delivers far beyond my expectations! 
              Communication with my ex was historically tense, but now it's clear, direct, and stress-free. 
              I highly recommend it.</div>
            <div style={{fontSize:'18px', fontStyle:'italic'}}>-Nikko</div>
          </div>
        </Typography>
        <div className={this.props.classes.imageContent}>
          <img  className={this.props.classes.halfImage} src={this.props.isFemale?"serenity-female.png":"serenity-male.png"} alt="Happy Parent"/>
        </div>
        {(this.props.isOnboarding === undefined || this.props.isOnboarding === false ) && 
          <Button onClick={() => {this.props.history.push("/app/settings/:userId");}}>{tn.lang.settings}</Button>}
        <div className={style.bottomContent} style={{marginBottom: '-20px'}}>
          <Button
            variant='contained'
            color='primary'
            size='large'
            fullWidth={true}
            disabled={buttonAction === undefined}
            onClick={buttonAction}
          >
            {buttonText}
          </Button>
          { this.state.alreadyHasASubscription && this.confetti() }
          <div onClick={() => this.setState({showPrivacyPolicy:true})}
            style={{position: 'absolute', bottom: '10px', opacity: 0.84, fontSize: '12px', fontWeight: 300}}>terms & privacy policy</div>
        </div>
        {this.state.showPrivacyPolicy?
          <QuickDialog
            open={this.state.showPrivacyPolicy}
            onClose={() => this.setState({showPrivacyPolicy: false})}
            title={tn.lang.privacyPolicyShort}
            content={tn.lang.privacyPolicyContent}
            actions={<div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
              <Button onClick={() => {this.props.history.push("/app/settings/:userId");}}>{tn.lang.settings}</Button>
              <Button
                onClick={() => this.setState({showPrivacyPolicy: false})}
                variant="text">
                {tn.lang.OK}
              </Button></div>}
          />:null}
        {this.renderPurchaseFeedback()}
      </>);
  }

  private renderWithTrialScreen(buttonText:JSX.Element, buttonAction:(()=> void)|undefined) {
    const style = this.props.classes;

    return (
      <>
        <Typography component={"div"} style={{flex:1, zIndex:1}}>
          <div style={{fontSize:'14px'}}>{tn.lang.subscriptionSubTitleMonth(this.state.daysOfTrial, this.state.price)}</div>
          <div style={{fontSize:'14px'}}>{tn.lang.subscriptionInvitedFree}</div>
          <div style={{display:'flex', flexDirection:'column', marginTop:'24px', position:'relative'}}>
            
            <div className={style.eventBox}>
              <UnlockIcon  className={style.iconStyled}/>
              <div>
                <div style={{fontWeight:'600'}}>{tn.lang.today}</div>
                <div className={style.eventDetails}>{tn.lang.subscriptionStepOne}</div>
              </div>
            </div>
            <div className={style.eventBox}>
              <NotificationsIcon className={style.iconStyled} style={{backgroundColor: "rgb(153 129 154)"}}/>
              <div>
                <div style={{fontWeight:'600'}}>{tn.lang.subscriptionStepTitle(this.state.daysOfTrial-2)}</div>
                <div className={style.eventDetails}>{tn.lang.subscriptionStepTwo}</div>
              </div>
            </div>
            <div className={style.eventBox}>
              <StarIcon className={style.iconStyled} style={{backgroundColor: "rgb(189 173 190)"}}/>
              <div>
                <div style={{fontWeight:'600'}}>{tn.lang.subscriptionStepTitle(this.state.daysOfTrial)}</div>
                <div className={style.eventDetails}>{tn.lang.subscriptionStepThree}</div>
              </div>
            </div>
            <div style={{position:'absolute', minWidth:'4px', height:'100%', background:'linear-gradient(0deg, #5d395f00, #5d395f)', left:'8px'}}/>
          </div>   
        </Typography>
        <div className={this.props.classes.imageContent}>
          <img  className={this.props.classes.halfImage} src={this.props.isFemale?"serenity-female.png":"serenity-male.png"} alt="Happy Parent"/>
        </div>
        {(this.props.isOnboarding === undefined || this.props.isOnboarding === false ) && 
          <Button onClick={() => {this.props.history.push("/app/settings/:userId");}}>{tn.lang.settings}</Button>}
        <div className={style.bottomContent} style={{marginBottom: '-20px'}}>
          <Button
            variant='contained'
            color='primary'
            size='large'
            fullWidth={true}
            disabled={buttonAction === undefined}
            onClick={buttonAction}
          >
            {buttonText}
          </Button>
          { this.state.alreadyHasASubscription && this.confetti() }
          <div onClick={() => this.setState({showPrivacyPolicy:true})}
            style={{position: 'absolute', bottom: '10px', opacity: 0.84, fontSize: '12px', fontWeight: 300}}>terms & privacy policy</div>
        </div>
        {this.state.showPrivacyPolicy?
          <QuickDialog
            open={this.state.showPrivacyPolicy}
            onClose={() => this.setState({showPrivacyPolicy: false})}
            title={tn.lang.privacyPolicyShort}
            content={tn.lang.privacyPolicyContent}
            actions={<div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
              <Button onClick={() => {this.props.history.push("/app/settings/:userId");}}>{tn.lang.settings}</Button>
              <Button
                onClick={() => this.setState({showPrivacyPolicy: false})}
                variant="text">
                {tn.lang.OK}
              </Button></div>}
          />:null}
        {this.renderPurchaseFeedback()}
      </>
    );
  }

  private renderFree(text:string) {
    const style = this.props.classes;

    return (
      <>
        <Typography component={"div"} style={{ flex: 1, zIndex: 1 }}>
          {tn.lang.subscriptionPaywall({ listStyleType: "none", margin: 0, padding: 0, gap: '10px', display: 'flex', flexDirection: 'column' })}
        </Typography>
        <div className={this.props.classes.imageContent}>
          <img className={this.props.classes.halfImage} src={this.props.isFemale ? "serenity-female.png" : "serenity-male.png"} alt="Happy Parent" />
        </div>
        <div className={style.bottomContent} style={{ marginBottom: '-20px' }}>
          {this.props.children}
          <Button
            variant='contained'
            color='primary'
            size='large'
            fullWidth={true}
            onClick={this.props.callBackSuccess}
          >
            <span>{text}</span>
          </Button>
        </div>
      </>
    );
  }


  private confetti = () => {
    // horizontal spread, relative to the centred anchor
    const offsets = [-90, -75, -60, -45, -30, -15, 0, 15, 30, 45, 60, 75, 90];

    /* ---- shuffle once, so dots launch in a random order ---- */
    const shuffled = offsets
      .map(x => ({ x, r: Math.random() })) // tag each offset with a random sort key
      .sort((a, b) => a.r - b.r)           // Fisher-Yates style shuffle
      .map(obj => obj.x);                  // back to plain numbers

    return (
      <div className={this.props.classes.confetti}>
        {shuffled.map((x, i) => (
          <span
            key={`${x}-${i}`}   // key must be unique after shuffling
            style={{
              left: x,
              /* launch timing: random 0-500 ms stagger */
              animationDelay: `${Math.floor(Math.random() * 500)}ms`,
              /* choose the drift: centre = straight up, sides drift outwards */
              animationName:
                x === 0 ? 'sparkUp' : x < 0 ? 'sparkUpLeft' : 'sparkUpRight',
            }}
          />
        ))}
      </div>
    );
  };


  private tick() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.updates++;
    if (this.updates === 80 ) {this.setState({showErrorState:true})}
    this.checkSubState();
    this.timer = setTimeout(() => this.tick(), 600);
  }

  private checkSubState() {

    // check that store is initialized
    const store = CdvPurchase.store;
    if (store && store.isReady && this.state.storeIsInitialized === false) {
      this.setState({storeIsInitialized:true});
    } else if ((!store || !store.isReady) && this.state.storeIsInitialized === true) {
      this.setState({storeIsInitialized:false});
      return;
    }

    // check legacy subscriptions
    const product4 = store.get("monthly4", this.platform); // this is no longer used but some might have this
    if (product4) {
      const product4Transaction: CdvPurchase.Transaction | undefined = store.findInLocalReceipts(product4);
      if (product4.owned) {
        if (this.state.alreadyHasASubscription === false) {
          this.setState({alreadyHasASubscription:true});
          return;
        }
      }
    }

    // check monthly subscription
    const product2 = store.get("monthly2", this.platform); // current month subscription
    if (product2) {

 
      // find price and trial length
      if (product2.offers && product2.offers.length > 0) {
        let price:string = "89 SEK";
        let trialPeriod:number = 0; // days of trial

        const offer:CdvPurchase.Offer = product2.offers[0];
        if (offer.pricingPhases && offer.pricingPhases.length > 1) {
          price = offer.pricingPhases[1].price; // this is the end price
          if (offer.pricingPhases[0].billingPeriod) { // this is the free trial period
            const testString = offer.pricingPhases[0].billingPeriod
            const regex = /^P(\d{1,2})([WMYD])(.*)?$/;
            const match = testString.match(regex);

            if (match) {
              const days = parseInt(match[1],10); // This will capture the number (1-99)
              const letter = match[2]; // This will capture the letter (W, M, Y, or D)
              
              if (letter === "D") {
                trialPeriod = days;
              } else if (letter === "W") {
                trialPeriod = days * 7;
              }  if (letter === "M") {
                trialPeriod = days * 30;
              }  if (letter === "Y") {
                trialPeriod = days * 365;
              } 
            }
          }
        } else if (product2.offers[0].pricingPhases && product2.offers[0].pricingPhases.length > 0) { // no free trial
          price = product2.offers[0].pricingPhases[0].price;
        }
        
        if (this.state.price !== price || this.state.daysOfTrial !== trialPeriod) {
          this.setState({price, daysOfTrial:trialPeriod});
        }

      } else { // no offer available something is wrong in setup of the price matrix in the appstore
        if (this.state.purchaseNotPossible === false) {
          this.setState({purchaseNotPossible:true})
        }
        return;
      }


      // Do we already own this / is this not buyable?
      if (product2.owned) {
        if (this.state.alreadyHasASubscription === false) {
          this.setState({alreadyHasASubscription:true});
          return;
        }
      } else if (!product2.canPurchase && this.state.buyRequestTime === 0) {
        if (this.state.purchaseNotPossible === false) {
          this.setState({purchaseNotPossible:true})
        }
        return;
      }
      
      // do we hace a current transaction?
      const product2Transaction: CdvPurchase.Transaction | undefined = store.findInLocalReceipts(product2);
      // The App Store adapter deletes its in-progress transaction when a purchase is cancelled or fails,
      // so a missing transaction must clear the state or the paywall stays on the waiting spinner.
      const transactionState = product2Transaction?.state;

      if (transactionState !== this.state.transactionState) {
        console.log("purchase state: "+transactionState);
        this.setState({transactionState})
      }
    } else {
      if (this.state.purchaseNotPossible === false) {
        this.setState({purchaseNotPossible:true})
      }
      return;
    }
  }

  private hasActiveBackendSubscription(subscriptions: ISubscription[]): boolean {
    for (const sub of subscriptions) {
      if (sub.disabled !== true && sub.expirationTime !== undefined && sub.expirationTime > Date.now()
        && (sub.platform === SubscriptionPlatform.APPLE || sub.platform === SubscriptionPlatform.GOOGLE 
          || sub.platform === SubscriptionPlatform.APPLE_TEST || sub.platform === SubscriptionPlatform.GOOGLE_TEST)) {
        return true;
      }
    }
    return false;
  }


}

function mapStateToProps(state: any) {
  const accountId = state.user.session.data.id;
  const subscriptions: ISubscription[] = state.subscriptions.subscriptions;
  let isFemale:boolean = true;
  const family:IFamilyMember[] = state.family.family?state.family.family:[];
  const me = family.find((mem) => mem.id === accountId);

  let multiGroup:boolean = false;

  if (state.user.session && state.user.session.data && state.user.session.data.resources) {
      const resources = state.user.session.data.resources;
      if (resources.length > 1) {
        multiGroup = true;
      }
  }

  if (me !== undefined && me.sex === "MAN") {isFemale = false}
  return {
    accountId,
    subscriptions,
    isFemale,
    multiGroup,
  };
}

const mapDispatchToProps = {
  subscribe: SubscriptionActions.subscribe,
  reportProblem: UserActions.reportProblem,
};

Subscription.contextType = cordovaContext;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(subscriptionStyle)(Subscription)));



// WEBPACK FOOTER //
// ./src/components/subscription/Subscription.tsx